// extracted by mini-css-extract-plugin
export default {"accountName":"HeaderMenu_accountName__LOGqg","menuItem":"HeaderMenu_menuItem__GWdHj"};